module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--pastlive-70934aac71a8dac6a665defe35804149.png";